<script setup>
import { ref, onMounted, computed, defineEmits } from 'vue';
import axios from '@/plugins/axios';
import Card from '@/components/cards/BaseCard.vue';

import { useStorage } from '@/composables/use-storage';

const { hasPermission } = useStorage();

const emit = defineEmits(['']);

const rfps = ref([]);
const screenSize = computed(() => window.innerWidth);
const isLoading = ref(false);

const getRFPs = async () => {
    isLoading.value = true;
    const response = await axios.get('api/listings/user_rfps')
    rfps.value = response.data.listings.sort((a, b) => {
        return new Date(b.created_at) - new Date(a.created_at);
    });
    isLoading.value = false;
};

const handleCreateRFP = () => {
    if(!hasPermission('rfp-create') || !hasPermission('buy')) {
        emit('showChangeGroupModal', true);
        return;
    }
    window.location.href = '/rfp/create';
};

const handleEditRFP = (id) => {
    window.location.href = `/rfp/edit/${id}`;
};

onMounted(async () => {
    await getRFPs();
});

</script>
<template>
    <div v-if="isLoading" class="flex justify-center items-center min-h-[500px] w-full">
        <div class="loading-spinner"></div>
    </div>
    
    <div v-else class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 2xl:grid-cols-5 gap-6 w-full">
        <Card :is-add-card="true" @add="handleCreateRFP" v-if="screenSize >= 768" />
        <Card 
            v-for="rfp in rfps" 
            :key="rfp.id" 
            :title="rfp.name" 
            :tags="rfp.tags"
            :description="rfp.description" 
            :eval_price="rfp?.eval_price || null"
            :show-edit="screenSize >= 768" 
            :image="rfp.preview_image" 
            :price="`$${rfp.price}`" 
            :currency="rfp.currency" 
            @edit="handleEditRFP(rfp.id)" 
        />
    </div>
</template>

<style scoped lang="postcss">
.loading-spinner {
  @apply w-8 h-8 border-4 border-echoes-border-gray border-t-echoes-primary rounded-full animate-spin;
}
</style>